import { memo } from 'react';
import ConfigMenu from '@layouts/toolbar/user/ConfigMenu';
import { UserMenu } from '@layouts/toolbar/user/UserMenu';
import SmallMenu from '@layouts/toolbar/user/SmallMenu';



const User = () => {

	return (
		<div className='toolbar-user'>

			<ConfigMenu />
			
			<UserMenu />
			
			<SmallMenu />
		
		</div>
	);
}

export default memo(User);